/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import "./footer.css";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import TwitterIcon from "@mui/icons-material/Twitter";
import GoogleIcon from "@mui/icons-material/Google";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Aos from "aos";
import "aos/dist/aos.css";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

const HrmsLandingFooter = () => {
    useEffect(() => {
        Aos.init({ duration: 800, once: true });
    }, []);

    return (
        <>
            <div className="footer">
                {/* Solutions */}
                <div className="row5" data-aos="fade-up">
                    <h4>Solutions</h4>
                    <span className="non-interactive">Employee Information Management</span>
                    <span className="non-interactive">Attendance & Time-Based Attendance Tracking</span>
                    <span className="non-interactive">Leave Management</span>
                    <span className="non-interactive">Payroll Management</span>
                    <span className="non-interactive">Expenses Management</span>
                    <span className="non-interactive">Advance Payments</span>
                </div>

                {/* Our Services */}
                <div className="row2" data-aos="fade-up">
                    <h4>Our Services</h4>
                    <span className="non-interactive">ERP Implementation</span>
                    <span className="non-interactive">HRM Implementation</span>
                    <span className="non-interactive">CRM Implementation</span>
                    <span className="non-interactive">Web Application</span>
                    <span className="non-interactive">Mobile Application</span>
                    <span className="non-interactive">High Performance Website Designing</span>
                    <span className="non-interactive">Third Party Outsourcing</span>
                    <span className="non-interactive">IT Consultancy</span>
                </div>

                {/* Company */}
                <div className="row3" data-aos="fade-up">
                    <h4>Company</h4>
                    <span className="non-interactive">Home</span>
                    <span className="non-interactive">Industries</span>
                    <span className="non-interactive">Solutions</span>
                    <span className="non-interactive">Pricing</span>
                </div>

                {/* Address + Social */}
                <div className="row4" data-aos="fade-up">
                    <span className="d-flex align-items-center mb-2">
                        <BusinessIcon
                            fontSize="medium"
                            style={{
                                background: "#2b87c7",
                                borderRadius: "50%",
                                color: "#fff",
                                padding: "6px",
                                marginRight: "8px",
                            }}
                            aria-hidden="true"
                        />
                        <h4 className="mb-0">TechCognics India Pvt. Ltd</h4>
                    </span>
                    <span className="d-flex align-items-center">
                        <LocationOnIcon
                            fontSize="medium"
                            style={{
                                background: "#2b87c7",
                                borderRadius: "50%",
                                color: "#fff",
                                padding: "6px",
                                marginRight: "8px",
                                marginTop: "2px",
                            }}
                            aria-hidden="true"
                        />
                        <div>
                            <span>Office No. 1010 & 1011, 10th Floor,</span><br />
                            <span>Gera’s Imperium Alpha, Kharadi, Pune</span><br />
                            <span>Maharashtra - 411014</span>
                        </div>
                    </span>
                    <span className="d-flex align-items-center">

                        <a
                            href="tel:+919890452720"
                            className="me-2"
                            aria-label="Call TechCognics at +91 9890452720"
                        >
                            <PhoneIcon
                                fontSize="medium"
                                className="grow"
                                aria-hidden="true"
                                style={{
                                    background: "#2b87c7",
                                    borderRadius: "50%",
                                    color: "#fff",
                                    padding: "6px",
                                }}
                            />
                        </a>


                        <span className="oldstyle">+91 9890452720</span>
                    </span>
                    <span className="d-flex align-items-center">
                        <a
                            href="mailto:sales@techcognicsindia.com"
                            className="me-2"
                            aria-label="Email TechCognics at sales@techcognicsindia.com"
                        >
                            <EmailIcon
                                fontSize="medium"
                                className="grow"
                                aria-hidden="true"
                                style={{
                                    background: "#2b87c7",
                                    borderRadius: "50%",
                                    color: "#fff",
                                    padding: "6px",
                                }}
                            />
                        </a>

                        <span>sales@techcognicsindia.com</span>
                    </span>


                    <div className="handles">
                        <h5>Follow Us</h5>
                        <div className="handle">
                            {/* Facebook */}
                            <a
                                href="https://www.facebook.com/profile.php?id=61565725310930"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                            >
                                <FacebookRoundedIcon
                                    fontSize="medium"
                                    className="grow"
                                    style={{
                                        background: "#1877F2",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                            </a>
                            <a
                                href="mailto:sales@techcognicsindia.com"
                                aria-label="Email TechCognics"
                            >
                                <GoogleIcon
                                    fontSize="medium"
                                    className="grow"
                                    aria-hidden="true"
                                    style={{
                                        background: "#dc6218",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                            </a>

                            {/* Instagram */}
                            <a
                                href="https://www.instagram.com/techcognicsindia/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                            >
                                <InstagramIcon
                                    fontSize="medium"
                                    className="grow"
                                    style={{
                                        background: "linear-gradient(45deg,#F58529,#DD2A7B,#8134AF,#515BD4)",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                            </a>

                            {/* Twitter / X */}
                            <a
                                href="https://x.com/TechCognicsInd"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Twitter X"
                            >
                                <TwitterIcon
                                    fontSize="medium"
                                    className="grow"
                                    style={{
                                        background: "#000",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                            </a>

                            {/* LinkedIn */}
                            <a
                                href="https://www.linkedin.com/company/techcognics-pvt-ltd/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LinkedIn"
                            >
                                <LinkedInIcon
                                    fontSize="medium"
                                    className="grow"
                                    style={{
                                        background: "#0A66C2",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                            </a>

                            {/* YouTube */}
                            <a
                                href="https://www.youtube.com/@TechCognics"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="YouTube"
                            >
                                <YouTubeIcon
                                    fontSize="medium"
                                    className="grow"
                                    style={{
                                        background: "#FF0000",
                                        borderRadius: "50%",
                                        color: "#fff",
                                        marginRight: "8px",
                                    }}
                                />
                            </a>
                        </div>

                    </div>
                </div>
            </div>

            {/* Bottom Footer */}
            <div className="footer_bottom">
                <div className="first_half">
                    © {new Date().getFullYear()} techcognicsindia.com – All rights reserved.
                </div>
                <div className="second_half">
                    Terms and Conditions | Privacy Policy | Site Map
                </div>
            </div>
        </>
    );
};

export default HrmsLandingFooter;
